
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.3047 5.51523C18.133 5.37193 17.9245 5.27977 17.703 5.24928C17.4815 5.21878 17.2558 5.25117 17.0518 5.34275L13.258 7.02893L11.0491 3.05283C10.9452 2.86574 10.7931 2.70986 10.6087 2.60132C10.4242 2.49278 10.2141 2.43555 10.0001 2.43555C9.78612 2.43555 9.576 2.49278 9.39156 2.60132C9.20712 2.70986 9.05506 2.86574 8.95115 3.05283L6.74216 7.02886L2.94778 5.34245C2.74362 5.25175 2.5182 5.21983 2.29689 5.25029C2.07558 5.28075 1.86716 5.37238 1.69511 5.51487C1.52305 5.65736 1.39419 5.84505 1.32302 6.05681C1.25185 6.26857 1.24121 6.49599 1.29229 6.71347L3.20068 14.8385C3.23699 14.9957 3.30499 15.144 3.40052 15.2741C3.49605 15.4043 3.61711 15.5136 3.7563 15.5953C3.89621 15.6777 4.05126 15.7311 4.21222 15.7524C4.37318 15.7737 4.53677 15.7624 4.69329 15.7192C8.16502 14.7607 11.8315 14.7604 15.3034 15.7182C15.4599 15.7613 15.6234 15.7726 15.7843 15.7513C15.9452 15.73 16.1001 15.6766 16.24 15.5943C16.3791 15.5126 16.5001 15.4034 16.5957 15.2734C16.6912 15.1433 16.7592 14.9952 16.7956 14.838L18.7073 6.71413C18.7593 6.49665 18.7491 6.26892 18.678 6.05694C18.6068 5.84495 18.4774 5.65724 18.3047 5.51523Z","fill":"#EE7F1A"}})])
          )
        }
      }
    